module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-clear-135f58c2a27a5faa385c5d5df1edbcf4.gif";